import React, { useMemo, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';

import { useWarehouseContext } from 'providers/WarehouseProvider';

import Table from 'components/common/Table';

import { orderApi } from 'api';

import {
  getOrderListTab,
  ORDER_LIST_COLUMNS,
  ORDER_FILTER_OPTIONS,
} from 'constants/order';

const Orders = () => {
  const tableRef = useRef();

  const { selectedWarehouse } = useWarehouseContext();
  const initialFilter = { warehouse: selectedWarehouse?.id };

  const handleOrderConnect = async orderId => {
    try {
      const response = await orderApi.connectOrders(orderId);

      if (response?.order_status === 'unfulfillable') {
        toast.error('Please check the product information');
      } else if (response?.order_status === 'processing') {
        toast.success('Order successfully connected');

        tableRef.current?.refetch();
      }
    } catch (error) {
      toast.error('Failed to connect order');
    }
  };

  const extendedColumns = useMemo(() => {
    const connectColumn = {
      id: 'connect',
      header: '',
      enableSorting: false,
      meta: {
        headerProps: { className: 'text-center' },
        cellProps: { className: 'text-center' },
      },
      cell: ({ row: { original } }) => {
        const { id, order_status } = original;

        const canConnect = ['unfulfillable', 'created'].includes(order_status);

        if (!canConnect) return null;

        return (
          <Button
            variant="success"
            size="sm"
            className="text-white"
            onClick={() => handleOrderConnect(id)}
          >
            Connect
          </Button>
        );
      },
    };

    return [...ORDER_LIST_COLUMNS, connectColumn];
  }, []);

  return (
    <Table
      ref={tableRef}
      title="Orders"
      apiService={orderApi}
      sortable={true}
      columns={extendedColumns}
      filterOptions={ORDER_FILTER_OPTIONS}
      tabOptions={getOrderListTab(initialFilter)}
      initialFilter={initialFilter}
    />
  );
};

export default Orders;
